import * as React from "react";

import { cn } from "./utils";

const Input = React.forwardRef<
  HTMLInputElement,
  React.ComponentPropsWithoutRef<"input">
>(({ className, type, ...props }, ref) => (
  <input
    ref={ref}
    type={type}
    data-slot="input"
    className={cn(
      "file:text-foreground placeholder:text-muted-foreground/80 selection:bg-primary selection:text-primary-foreground border-input/75 flex h-11 w-full min-w-0 max-w-full rounded-[0.9rem] border bg-input-background/78 px-3.5 py-2 text-base shadow-[inset_0_1px_0_rgb(255_255_255_/_0.2),0_1px_2px_rgb(15_23_42_/_0.04)] backdrop-blur-xl transition-[color,box-shadow,background-color,border-color] outline-none hover:border-accent/45 hover:bg-card/90 file:inline-flex file:h-7 file:max-w-full file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
      "focus-visible:border-ring focus-visible:bg-card focus-visible:ring-ring/20 focus-visible:ring-[4px]",
      "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
      className,
    )}
    {...props}
  />
));

Input.displayName = "Input";

export { Input };
